import { Map, Set } from 'immutable';
import { validateField } from './newsletterFormBlockValidation';
export const genderValues = [
    'F',
    'M'
];
export const genderLabels = {
    F: 'Vrouw',
    M: 'Man'
};
export const newslettersId = [
    3,
    119,
    12,
    5,
    126,
    100,
    134
];
export const newsletterName = {
    3: 'Nieuwsbrief',
    119: 'Junior Nieuws',
    12: 'Nieuwsbrief BoekStart in de Kinderopvang',
    5: 'Nieuwsbrief Basisonderwijs',
    126: 'Nieuwsbrief Educatie 12+',
    100: 'Kennemerwaard College',
    134: 'Nieuws vanuit Participatie & Zelfredzaamheid'
};
export const newsletterLabel = {
    3: 'Blijf maandelijks op de hoogte van jouw bieb, over activiteiten en andere wetenswaardigheden.',
    119: 'Om de maand lees en doe tips voor jeugd en jongeren in je mailbox. Haal meer uit de Bibliotheek voor jouw gezin!',
    12: 'Uitnodigingen voor bijeenkomsten, tips en nieuws voor professionals in de voorschoolse educatie.',
    5: 'Tips en nieuws voor professionals in het primair onderwijs.',
    126: 'Tips en nieuws voor professionals in het voortgezet onderwijs en beroepsonderwijs.',
    100: 'Blijf op de hoogte van trainingen en bijeenkomsten voor professionals in het onderwijs.',
    134: 'Ontvang één keer per kwartaal het laatste nieuws op het gebied van Participatie & Zelfredzaamheid vanuit de bibliotheek.'
};
export const initialFormState = {
    emailAddress: '',
    firstName: '',
    lastName: '',
    gender: undefined,
    newsletters: Set()
};
export const allFields = Object.keys(initialFormState);
export const initialState = {
    data: initialFormState,
    visited: Set(),
    validationMessages: Map(),
    status: 'initial',
    errorMessage: ""
};
export const setFieldOnState = (setState)=>(field)=>(value)=>setState((s)=>({
                    ...s,
                    data: {
                        ...s.data,
                        [field]: value
                    }
                }));
export const toggleNewsletterOnState = (setState)=>(value)=>setState((s)=>({
                ...s,
                data: {
                    ...s.data,
                    newsletters: s.data.newsletters.has(value) ? s.data.newsletters.remove(value) : s.data.newsletters.add(value)
                }
            }));
export const setVisited = (setState)=>(field)=>setState((s)=>({
                ...s,
                visited: s.visited.add(field)
            }));
export const validateFormData = (setState)=>(all)=>setState((prevState)=>{
            const fields = all ? allFields : prevState.visited.toArray();
            const validationMessages = validateFields(fields, prevState.data);
            // When "all fields" is triggered once, ensure all is validated on updates
            const visited = Set(fields);
            return {
                ...prevState,
                validationMessages,
                visited
            };
        });
export const validateFields = (fields, data)=>fields.reduce((messages, field)=>{
        const result = validateField(field)(data[field]);
        return result.status == 'invalid' ? messages.set(field, result.message) : messages;
    }, Map());
